import { Component, OnInit } from '@angular/core';
import {RealmService} from '../Services/Realm/realm.service';
import {FirebaseService} from '../Services/Firebase/firebase.service';
import {ApiService} from '../Services/Api/api.service';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-benefit',
  templateUrl: './benefit.component.html',
  styleUrls: ['../../assets/layout/style/layout.css', './benefit.component.css']
})
export class BenefitComponent implements OnInit {
  benefits: any;
  items: any[] = [];
  titleBenefit: string;
  subTitleBenefit: string;
  env = environment;
  constructor(private realm: RealmService,
              public Rc: FirebaseService, private api: ApiService) { }

  ngOnInit() {
    this.env.isContentLoading = true;
    this.realm.loginAsync().then(val => {
      this.realm.getBenefitSettings();
    });
    this.Rc.fetchActivate().then(() => {
      this.getRemoteConfig();
     });
    this.api.responseGetBenefit$.subscribe( data => {
      const dat = JSON.parse(JSON.stringify(data));
      //console.log(JSON.stringify(data) + " benefit component.ts 26");
      if (dat.code === 701) {
        // @ts-ignore
        const s: object = dat.resultBenefits.success;
        this.benefits = s;
        this.env.isContentLoading = false;
        //console.log('data ws: ', this.benefits);
        this.benefits.map((benefit) => {
          let group:string = benefit.benefitGroup;
          console.log(group);
          if ( group == "Servicios Contratados" ) {
            console.log("entra a servicios contratados");
            benefit.detail.map((service) => {
              let icon:string = service.nameIcon;
              console.log(icon);
              if ( icon == "xray" ) {
                service.nameIcon = "../../assets/images/benefits/rayos_X.png";
              } else if ( icon == "labs" ) {
                service.nameIcon = "../../assets/images/benefits/laboratorios.png";
              } else if ( icon == "medicine" ) {
                service.nameIcon = "../../assets/images/benefits/medicamentos.png";
              } else if ( icon == "hospital" ) {
                service.nameIcon = "../../assets/images/benefits/hispitalizacion.png";
              } else if ( icon == "specialProcedure" ) {
                service.nameIcon = "../../assets/images/benefits/laboratorios.png";
              } else if ( icon == "colonoscopy" ) {
                service.nameIcon = "../../assets/images/benefits/gatroscopia.png";
              } else if ( icon == "ambulatory" ) {
                service.nameIcon = "../../assets/images/benefits/quirurgicos.png";
              } else if ( icon == "emergency" ) {
                service.nameIcon = "../../assets/images/benefits/emergencia.png";
              } else if ( icon == "oncology" ) {
                service.nameIcon = "../../assets/images/benefits/tratamiento-oncologico.png";
              } else if ( icon == "fisioteraphy" ) {
                service.nameIcon = "../../assets/images/benefits/fisioterapia.png";
              } else if ( icon == "urgent" ) {
                service.nameIcon = "../../assets/images/benefits/urgencia-medica.png";
              } else if ( icon == "ambulatoryHospital" ) {
                service.nameIcon = "../../assets/images/benefits/ambulatoriosl.png";
              } else if ( icon == "magneticResonance" ) {
                service.nameIcon = "../../assets/images/benefits/resonancia.png";
              } else if ( icon == "consult" ) {
                service.nameIcon = "../../assets/images/benefits/consulta_externa.png";
              } else {
                service.nameIcon = "../../assets/images/benefits/procedimientos_clinica.png";
              }
            })  
          }
          
        })
        console.log(this.benefits);
        if (s.hasOwnProperty('success')) {

        }
      } else {
        this.env.isContentLoading = false;
      }
    });
  }

  getRemoteConfig() {
    this.titleBenefit = this.Rc.getStringRC('txt_title_benefit');
    this.subTitleBenefit = this.Rc.getStringRC('txt_subtitle_benefit');
  }

}
